<template lang="pug">
v-form.d-flex.flex-column.flex-grow-1.flex-shrink-1( ref="bankAccountForm" )
  app-card-title Банковские реквизиты
  app-text-field( v-model="form.orgName" label="Наименование организации получателя" )
  app-text-field( v-model="form.inn" label="ИНН получателя" :rules="[rules.required, rules.number]" )
  app-text-field( v-model="form.kpp" label="КПП получателя" :rules="[rules.required, rules.number]" )
  app-text-field( v-model="form.bill" label="Расчетный счет" :rules="[rules.required, rules.number]" )
  app-text-field( v-model="form.bankBik" label="БИК банка получателя" :rules="[rules.required, rules.number]" @change="getPayerBank(form.bankBik)" )
  app-text-field( v-model="form.bank" label="Наименование банк получателя" readonly )
  app-text-field( v-model="form.bankCorrBill" label="Корреспондентский счет банка" readonly )
  
  app-text-field( v-model="form.oktmo" label="ОКТМО" :rules="[rules.required, rules.number]" )
  app-text-field( v-model="form.kbk" label="КБК" :rules="[rules.required, rules.number]" )
</template>

<script>
import { $_validate_rules } from '@/common/ValidateRules'
import { mapActions } from 'vuex'

export default {
  name: "ExpertBankAccountForm",
  mixins: [$_validate_rules],
  props: {
    form: null,
  },

  methods: {
    ...mapActions('expert', ['getBankInfo']),

    getPayerBank(bik) {
      if (bik) {
        this.getBankInfo(bik).then(data => {
          this.form.bank = data?.name ?? ""
          this.form.bankCorrBill = data?.account ?? ""
        })
      }
    },
  },
  
}
</script>